import { fetchWithAuth } from "../apiutil";

export const usersAPI = {
  /**
   * Load users
   * @param {string} accessToken - Current access token
   * @returns {Promise<Object>} Response with users data
   */
  loadUsers: async (accessToken) => {
    return fetchWithAuth("/api/users", { method: "GET" }, accessToken);
  },
};
